var link_viewer_default = {
  "fontElementMap": "GXTiR",
  "link": "rJEfu",
  "linkInEditor": "Vj6Kp",
  "linkInViewer": "fP51A",
  "toolbarUrlContainer": "Adq2Z",
  "toolbarUrl": "TEwBV",
  "toolbarUrlAnchor": "-vxay"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
